import { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import EmployerHeaderScreen from "../../component/layout/employerheader";
import EmployerSidebarScreen from "../../component/layout/employer-sidebar";
import AuthFooterScreen from "../../component/layout/authfooter";
import Table from "react-bootstrap/Table";
import { LuEye } from "react-icons/lu";
import { AiOutlineDelete } from "react-icons/ai";
import Form from "react-bootstrap/Form";
import { RiDeleteBinLine } from "react-icons/ri";
import { MdEdit } from "react-icons/md";
import {
  ManageJobApi,
  DeleteJobApi,
  viewJobApi,
} from "../../service/apis/employer.api";
import { toast } from "react-toastify";
//import "react-toastify/dist/ReactToastify.css";
// import { AppRoute } from "../../router/routerConstants";
import { useNavigate } from "react-router-dom";
import { useCustomNavigate } from "../../hooks/useCustomNavigate";
import Loader from "../../common/Loader/loader";
import CustomPagination from "../../component/custom-pagination";
import { AppRoute } from "../../router/routerConstants";

const ManageJobsScreen = () => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  //const handleShow = () => setShow(true);

  // const [showdell, setShowdell] = useState(false);
  // const handleCloseDL = () => setShowdell(false);
  //const handleShowDl = () => setShowdell(true);

  // For Delete job
  const [showdlte, setShowdlte] = useState(false);
  const [jobToDelete, setJobToDelete] = useState(null);
  // For Delete job ends

  const [responseData, setResponseData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [selectedJob, setSelectedJob] = useState<any>(null);
  const [NavigateTo] = useCustomNavigate();

  const [isLoading, setIsLoading] = useState(false);

  const manageJobPost = async (pagee: number) => {
    setIsLoading(true);
    try {
      const response = await ManageJobApi(pagee);
      //console.log(response.jobs.jobs);
      setResponseData(response.jobs.jobs);
      setCurrentPage(response.jobs.page);
      setTotalPages(response.jobs.totalPages);
    } catch (error) {
      console.error("Error API:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    /*const manageJobPost = async () => {
			try {
				const response = await ManageJobApi(currentPage);
				console.log(response.jobs.jobs);
				setResponseData(response.jobs.jobs);
				setCurrentPage(response.jobs.page);
				setTotalPages(response.jobs.totalPages);
			} catch (error) {
				console.error("Error API:", error);
			}
		};*/
    manageJobPost(currentPage);
  }, [currentPage]);

  const handlePageChange = (page: any) => {
    setCurrentPage(page);
  };

  // Handle Delete Modal
  const handleCloseDelete = () => {
    setShowdlte(false);
    setJobToDelete(null); // Reset job ID
  };

  const handleShowDelete = (jobId: any) => {
    setShowdlte(true);
    setJobToDelete(jobId); // Set job ID to delete
  };

  // Delete Job
  const handleDeleteJob = async () => {
    if (!jobToDelete) return;

    try {
      const response = await DeleteJobApi(jobToDelete);
      //console.log(response);
      handleCloseDelete(); // Close modal
      manageJobPost(currentPage); // Refresh job list
      if (response.message === "Job deleted successfully") {
        toast.success(response.message);
      } else {
        toast.error("Delete failed!!");
      }
    } catch (error) {
      console.error("Error deleting job:", error);
      toast.error("Error deleting job!!");
    }
  };
  // Handle Delete Modal ends

  // View job
  const handleShow = async (jobId: any) => {
    // setIsLoading(true);
    try {
      const data = await viewJobApi(jobId);
      //console.log(data);
      setSelectedJob(data); // Update state with fetched data
      setShow(true); // Open modal
    } catch (error) {
      console.error("Error fetching job details:", error);
    } finally {
      // setIsLoading(false);
    }
  };
  //View job ends

  const handleViewAllApplicants = (jobId: string) => {
    //console.log("jobId", jobId);
    NavigateTo(AppRoute.EMPLOYER_APPLICANTS, false, { jobId: jobId });
  };

  // console.log("Managee:",responseData);

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="main">
          <section className="profileJoblisting-area">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-2 sidebar position-relative p-0">
                  <EmployerSidebarScreen />
                </div>
                <div className="col-lg-10 rightcontent p-0">
                  <EmployerHeaderScreen />
                  <div className="profileJoblisting-holder rightInnerScroll">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="applied-title">
                          <div className="title">
                            <h2>Manage Jobs</h2>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="appliedJobsTable managejobtable">
                          <div className="table-responsive">
                            <Table>
                              <thead>
                                <tr>
                                  <th>Jobs</th>
                                  <th>Applicants</th>
                                  <th>Shortlisted</th>
                                  <th>Rejected</th>
                                  <th>Hired</th>
                                  <th>View Applicant</th>
                                  <th>Action</th>
                                </tr>
                              </thead>

                              <tbody>
                                {responseData && responseData.length > 0 ? (
                                  responseData.map((job: any) => (
                                    <tr key={job._id}>
                                      <td>
                                        <h3>{job.title}</h3>
                                        <ul className="postdate">
                                          {/*12 Sep 2024*/}

                                          {(() => {
                                            const createdAt = job.createdAt;
                                            const date = new Date(createdAt);
                                            const formattedDate =
                                              date.toLocaleDateString("en-GB", {
                                                day: "2-digit",
                                                month: "short",
                                                year: "numeric",
                                              });
                                            return (
                                              <li>
                                                Created on: {formattedDate}
                                              </li>
                                            );
                                          })()}

                                          <li>
                                            Expires on:{" "}
                                            {new Date(
                                              job.deadlineDate
                                            ).toLocaleDateString("en-GB", {
                                              day: "2-digit",
                                              month: "short",
                                              year: "numeric",
                                            })}
                                          </li>
                                        </ul>
                                      </td>
                                      <td>{job.applicationsSummary.applied}</td>
                                      <td>
                                        {job.applicationsSummary.shortlisted}
                                      </td>
                                      <td>
                                        {job.applicationsSummary.rejected}
                                      </td>
                                      <td>{job.applicationsSummary.hired}</td>
                                      <td>
                                        {/* <a className="moreview" href="/employer/applicants">View Applicates</a> */}
                                        {/* eslint-disable-next-line  */}
                                        <a className={`moreview `+(job.applicationsSummary.applied>0?``:`disabled`)} onClick={() => handleViewAllApplicants(job._id) } href="javascript:void(0)" > View Applicant </a>
                                      </td>
                                      <td>
                                        <ul>
                                          <li>
                                            <Button
                                              className="btnnoStyle"
                                              variant="primary"
                                              onClick={() =>
                                                handleShow(job._id)
                                              }
                                            >
                                              <LuEye />
                                            </Button>
                                          </li>
                                          <li>
                                            <Button
                                              className="btnnoStyle"
                                              variant="primary"
                                              onClick={() => {
                                                navigate(
                                                  `/employer/edit-job/${job._id}`
                                                );
                                              }}
                                            >
                                              <MdEdit />
                                            </Button>
                                          </li>
                                          <li>
                                            <Button
                                              className="btnnoStyle red"
                                              variant="primary"
                                              onClick={() =>
                                                handleShowDelete(job._id)
                                              }
                                            >
                                              {" "}
                                              <AiOutlineDelete />
                                            </Button>
                                          </li>
                                        </ul>
                                      </td>
                                    </tr>
                                  ))
                                ) : responseData.length === 0 ? (
                                  <tr>
                                    <td colSpan={7} className="text-center">
                                      No jobs found.
                                    </td>
                                  </tr>
                                ) : (
                                  <Loader />
                                )}
                              </tbody>
                            </Table>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12 paginationholder align-left mb-5">
                          {/* <Pagination>
								<Pagination.Prev />
								<Pagination.Item>{1}</Pagination.Item>
								<Pagination.Item active>{2}</Pagination.Item>
								<Pagination.Item>{3}</Pagination.Item>
								<Pagination.Ellipsis />
								<Pagination.Item>{6}</Pagination.Item>
								<Pagination.Next />
							</Pagination> */}

                          {/* <Pagination>
									{currentPage > 1 && (
									<Pagination.Prev
										onClick={() =>
										currentPage > 1 &&
										handlePageChange(currentPage - 1)
										}
										disabled={currentPage === 1}
									/>
									)}

									{currentPage > 2 && (
									<>
										<Pagination.Item
										onClick={() => handlePageChange(1)}
										>
										1
										</Pagination.Item>
										<Pagination.Ellipsis />
									</>
									)}

									{Array.from({ length: totalPages }, (_, index) => {
									const pageNumber = index + 1;

									// Show pages around currentPage and hide unnecessary ones
									if (
										pageNumber >= currentPage - 1 &&
										pageNumber <= currentPage + 1
									) {
										return (
										<Pagination.Item
											key={pageNumber}
											active={pageNumber === currentPage}
											onClick={() => handlePageChange(pageNumber)}
										>
											{pageNumber}
										</Pagination.Item>
										);
									}

									// Show first and last page when necessary
									if (currentPage === 1 && pageNumber <= 3) {
										return (
										<Pagination.Item
											key={pageNumber}
											active={pageNumber === currentPage}
											onClick={() => handlePageChange(pageNumber)}
										>
											{pageNumber}
										</Pagination.Item>
										);
									}

									if (
										currentPage === totalPages &&
										pageNumber >= totalPages - 2
									) {
										return (
										<Pagination.Item
											key={pageNumber}
											active={pageNumber === currentPage}
											onClick={() => handlePageChange(pageNumber)}
										>
											{pageNumber}
										</Pagination.Item>
										);
									}

									return null;
									})}

									{currentPage < totalPages - 1 && (
									<>
										<Pagination.Ellipsis />
										<Pagination.Item
										onClick={() => handlePageChange(totalPages)}
										>
										{totalPages}
										</Pagination.Item>
									</>
									)}

									{currentPage < totalPages && (
									<Pagination.Next
										onClick={() =>
										currentPage < totalPages &&
										handlePageChange(currentPage + 1)
										}
										disabled={currentPage === totalPages}
									/>
									)}
								</Pagination> */}

                          <CustomPagination
                            totalPages={totalPages}
                            currentPage={currentPage}
                            onPageChange={handlePageChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      )}
      <AuthFooterScreen />

      {/* View job */}
      <Modal
        show={show}
        onHide={handleClose}
        animation={false}
        aria-labelledby="contained-modal-title-vcenter"
        className="findajobmodal"
        centered
      >
        <button
          type="button"
          className="btn-close custom-close-btn"
          onClick={handleClose}
          aria-label="Close"
          style={{
            position: "absolute",
            top: "15px",
            right: "15px",
            zIndex: 9,

            border: "none",
            fontSize: "1rem",
            cursor: "pointer",
          }}
        ></button>

        <Modal.Body>
          {selectedJob ? (
            <div className="afterapplied">
              <div className="aplyinfo">
                <div className="d-flex flex-btn  justify-content-lg-between">
                  <h4>
                    <strong>Job Title:</strong> {selectedJob?.job?.title}
                  </h4>
                  <div className="status gray first-capital">
                    {selectedJob?.job?.admin_status === "approved"
                      ? selectedJob?.job?.status
                      : selectedJob?.job?.admin_status}
                  </div>
                </div>
                <h4>
                  <strong>Category:</strong>{" "}
                  {selectedJob?.job?.category?.categoryName}
                </h4>
                <h4>
                  <strong>Type:</strong> {selectedJob?.job?.type?.typeName}
                </h4>
                <h4>
                  <strong>Applicants:</strong> {selectedJob?.Count}
                </h4>
                <h4>
                  <strong>Post Date:</strong>{" "}
                  {new Date(selectedJob?.createdAt).toLocaleDateString(
                    "en-US",
                    {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    }
                  )}
                </h4>
                <h4>
                  <strong>Expire Date:</strong>{" "}
                  {new Date(selectedJob?.job?.deadlineDate).toLocaleDateString(
                    "en-US",
                    {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    }
                  )}
                </h4>
                <div className="flex-btn d-flex">
                  <Button
                    className="btn w-50 btn-black"
                    variant="primary"
                    onClick={() => {
                      handleShowDelete(selectedJob?.job?.id);
                      handleClose();
                    }}
                  >
                    Delete Job Post
                  </Button>
                  <Button
                    className="btn w-50"
                    variant="primary"
                    onClick={() =>
                      handleViewAllApplicants(selectedJob?.job?.id)
                    }
                  >
                    View All Applicants
                  </Button>
                </div>
              </div>
            </div>
          ) : (
            <p>No job details available</p>
          )}
        </Modal.Body>
      </Modal>
      {/* View job ends*/}

      {/* Delete Job modal*/}
      <Modal
        show={showdlte}
        onHide={handleCloseDelete}
        animation={false}
        aria-labelledby="contained-modal-title-vcenter"
        className="editPersonalInformation"
        centered
      >
        <Modal.Body>
          <div className="findbody text-center">
            <Form className="logoutmdl">
              <div className="logouticon">
                <RiDeleteBinLine />
              </div>
              <h3>Delete Job</h3>
              <p>Are you sure you want to delete this job?</p>
              <p>
                After deletion, you will no longer be able to access this job.
              </p>
              <div className="d-flex gp-10">
                <Button
                  className="btn btn-black w-100"
                  type="button"
                  onClick={handleCloseDelete}
                >
                  Cancel
                </Button>
                <Button
                  className="btn  w-100"
                  type="button"
                  onClick={handleDeleteJob}
                >
                  Delete
                </Button>
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
      {/* Delete Job modal ends*/}
    </>
  );
};
export default ManageJobsScreen;
